import {faker}  from "@faker-js/faker";
import { getOrgApp } from "../helpers/get-orgApp";

export const allIAMRoles = async () => {
  let orgAppDetails = await getOrgApp();
  let selectedOrg = faker.helpers.arrayElement(orgAppDetails);
  let selectedDept = faker.helpers.arrayElement(selectedOrg.depts);
  return [
    {
      ResourceName: "ELSCloudformationRole",
      ARN: "arn:aws:iam::717912345678:role/ELSCloudformationRole",
      ResourceId: "AROAXYE52GKZNF7NMXUHG",
      Provider: "Aws",
      Region: "global",
      DepartmentId: selectedDept,
      ApplicationId: "default",
      CreatedOn: "2020-02-26 10:05:27",
      ModifiedOn: "2020-02-26 10:05:27",
      ResourceTags: [],
      ResourceType: "IAMRole",
      Domain: "Security",
      AccountNumber: "500608819332",
      OrganizationId: selectedOrg,
      EnvironmentId: "default",
      CreatedBy: null,
      ModifiedBy: null,
    },
    {
      ResourceName: "MontyCloud-BYOACloudFormationRole",
      ARN: "arn:aws:iam::717912345678:role/MontyCloud-BYOACloudFormationRole",
      ResourceId: "AROAXYE52GKZNF7NMXUHG",
      Provider: "Aws",
      Region: "global",
      DepartmentId: selectedDept,
      ApplicationId: "default",
      CreatedOn: "2020-02-26 10:05:27",
      ModifiedOn: "2020-02-26 10:05:27",
      ResourceTags: [],
      ResourceType: "IAMRole",
      Domain: "Security",
      AccountNumber: "500608819332",
      OrganizationId: selectedOrg,
      EnvironmentId: "default",
      CreatedBy: null,
      ModifiedBy: null,
    },
    {
      ResourceName: "CloudTrail_CloudWatchLogs_Role",
      ARN: "arn:aws:iam::717912345678:role/CloudTrail_CloudWatchLogs_Role",
      ResourceId: "AROAXYE52GKZNQPCEO6DL",
      Provider: "Aws",
      Region: "global",
      DepartmentId: selectedDept,
      ApplicationId: "default",
      CreatedOn: "2020-02-26 10:05:27",
      ModifiedOn: "2020-02-26 10:05:27",
      ResourceTags: [],
      ResourceType: "IAMRole",
      Domain: "Security",
      AccountNumber: "591335929153",
      OrganizationId: selectedOrg,
      EnvironmentId: "default",
      CreatedBy: null,
      ModifiedBy: null,
    },
    {
      ResourceName: "Acme_Application_Role",
      ARN: "arn:aws:iam::717912345678:role/Acme_Application_Role",
      ResourceId: "AROAXYE52GKZNTEZZ3752",
      Provider: "Aws",
      Region: "global",
      DepartmentId: selectedDept,
      ApplicationId: "default",
      CreatedOn: "2020-02-26 10:05:27",
      ModifiedOn: "2020-02-26 10:05:27",
      ResourceTags: [],
      ResourceType: "IAMRole",
      Domain: "Security",
      AccountNumber: "932383143047",
      OrganizationId: selectedOrg,
      EnvironmentId: "default",
      CreatedBy: null,
      ModifiedBy: null,
    },
    {
      ResourceName: "AWS_Role_For_EKS_Nodegroup",
      ARN: "arn:aws:iam::717912345678:role/AWS_Role_For_EKS_Nodegroup",
      ResourceId: "AROAXYE52GKZNUJW55UX7",
      Provider: "Aws",
      Region: "global",
      DepartmentId: selectedDept,
      ApplicationId: "default",
      CreatedOn: "2020-02-26 10:05:27",
      ModifiedOn: "2020-02-26 10:05:27",
      ResourceTags: [],
      ResourceType: "IAMRole",
      Domain: "Security",
      AccountNumber: "479922861820",
      OrganizationId: selectedOrg,
      EnvironmentId: "default",
      CreatedBy: null,
      ModifiedBy: null,
    },
    {
      ResourceName: "AWS_Events_Invoke",
      ARN: "arn:aws:iam::717912345678:role/AWS_Events_Invoke",
      ResourceId: "AROAXYE52GKZNXZ7FQTQT",
      Provider: "Aws",
      Region: "global",
      DepartmentId: selectedDept,
      ApplicationId: "default",
      CreatedOn: "2020-02-26 10:05:27",
      ModifiedOn: "2020-02-26 10:05:27",
      ResourceTags: [],
      ResourceType: "IAMRole",
      Domain: "Security",
      AccountNumber: "771592380082",
      OrganizationId: selectedOrg,
      EnvironmentId: "default",
      CreatedBy: null,
      ModifiedBy: null,
    },
    {
      ResourceName: "SSM-role",
      ARN: "arn:aws:iam::717912345678:role/SSM",
      ResourceId: "AROAXYE52GKZO54HCIGRJ",
      Provider: "Aws",
      Region: "global",
      DepartmentId: selectedDept,
      ApplicationId: "default",
      CreatedOn: "2020-02-26 10:05:27",
      ModifiedOn: "2020-02-26 10:05:27",
      ResourceTags: [],
      ResourceType: "IAMRole",
      Domain: "Security",
      AccountNumber: "771592380081",
      OrganizationId: selectedOrg,
      EnvironmentId: "default",
      CreatedBy: null,
      ModifiedBy: null,
    },
    {
      ResourceName: "AWS_Role_For_CloudWatch",
      ARN: "arn:aws:iam::717912345678:role/AWS_Role_For_CloudWatch",
      ResourceId: "AROAXYE52GKZO66SX7O3Q",
      Provider: "Aws",
      Region: "global",
      DepartmentId: selectedDept,
      ApplicationId: "default",
      CreatedOn: "2020-02-26 10:05:27",
      ModifiedOn: "2020-02-26 10:05:27",
      ResourceTags: [],
      ResourceType: "IAMRole",
      Domain: "Security",
      AccountNumber: "771592380085",
      OrganizationId: selectedOrg,
      EnvironmentId: "default",
      CreatedBy: null,
      ModifiedBy: null,
    },
    {
      ResourceName: "MontyCloud-test-terraform2-Role-v1-dev1",
      ARN: "arn:aws:iam::717912345678:role/MontyCloud-test-terraform2-Role-v1-dev1",
      ResourceId: "AROAXYE52GKZO66SX7O3Q",
      Provider: "Aws",
      Region: "global",
      DepartmentId: selectedDept,
      ApplicationId: "default",
      CreatedOn: "2020-02-26 10:05:27",
      ModifiedOn: "2020-02-26 10:05:27",
      ResourceTags: [],
      ResourceType: "IAMRole",
      Domain: "Security",
      AccountNumber: "771592380085",
      OrganizationId: selectedOrg,
      EnvironmentId: "default",
      CreatedBy: null,
      ModifiedBy: null,
    },
  ];
};

export const allKeyPairs = () => {
  return [
    {
      ResourceName: "DataPipeline",
      ResourceId: "DataPipeline",
      AccountNumber: "500608819332",
      RegionCode: "us-east-1",
    },
    {
      ResourceName: "ElasticSearch",
      ResourceId: "ElasticSearch",
      AccountNumber: "591335929153",
      RegionCode: "us-east-1",
    },
    {
      ResourceName: "RedshiftDR",
      ResourceId: "RedshiftDR",
      AccountNumber: "932383143047",
      RegionCode: "us-east-1",
    },
    {
      ResourceName: "Taskcat",
      ResourceId: "Taskcat",
      AccountNumber: "771592380082",
      RegionCode: "us-east-1",
    },
    {
      ResourceName: "TCO-EDH-TEST",
      ResourceId: "TCO-EDH-TEST",
      AccountNumber: "771592380081",
      RegionCode: "us-east-1",
    },
    {
      ResourceName: "WA-Test",
      ResourceId: "WA-Test",
      AccountNumber: "771592380085",
      RegionCode: "us-east-1",
    },
  ];
};

export const getIamRoleDetails = (roleName) => {
  return [
    {
      PolicyName: roleName,
      PolicyArn: "arn:aws:iam::668498814854:policy/" + roleName,
      PolicyJson: {
        Version: "2012-10-17",
        Statement: [
          {
            Action: ["iam:*"],
            Resource: "*",
            Effect: "Allow",
            Sid: "IAMPermissions",
          },
          {
            Action: "ssm:*",
            Resource: "*",
            Effect: "Allow",
            Sid: "SSMPermissions",
          },
          {
            Action: "ec2:*",
            Resource: "*",
            Effect: "Allow",
            Sid: "EC2Permissions",
          },
          {
            Action: ["SNS:Publish"],
            Resource: "*",
            Effect: "Allow",
            Sid: "SNS",
          },
          {
            Action: [
              "cloudformation:DescribeStackResource",
              "cloudformation:CreateChangeSet",
              "cloudformation:DescribeStackEvents",
              "cloudformation:DescribeChangeSet",
              "cloudformation:ExecuteChangeSet",
              "cloudformation:SignalResource",
              "cloudformation:DescribeStacks",
              "cloudformation:CreateStack",
              "cloudformation:DeleteStack",
              "cloudformation:ValidateTemplate",
            ],
            Resource: "*",
            Effect: "Allow",
            Sid: "CloudFormation",
          },
          {
            Action: ["cloudwatch:PutMetricAlarm", "cloudwatch:DeleteAlarms"],
            Resource: "*",
            Effect: "Allow",
            Sid: "CloudWatchPermission",
          },
          {
            Action: ["s3:GetObject"],
            Resource: ["arn:aws:s3:::mc-dev1-blueprints/ec2instance_linux/*"],
            Effect: "Allow",
            Sid: "S3CrossAccountPermission",
          },
        ],
      },
    },
  ];
};
